import { Injectable } from "@angular/core";
import * as moment from "moment";
import { SignalRConnection } from "ng2-signalr";
import { UserPreference } from "../../models/UserPreference";
import { errorMessages } from "../../settings";
import { CommonService } from "../common.service";
import { DashboardService } from "../dashboard.service";
import { WidgethelperService } from "../widgethelper.service";

@Injectable()
export class OpenorderService {

  private hub: SignalRConnection;
  labelSetting = {
    normal: {
      show: true,
      position: "outside",
      offset: [10, 0],
      textStyle: {
        fontSize: 18,
        fontFamily: "lato",
        color: "#ccc"
      }
    }
  };

  constructor(
    private _dashboardService: DashboardService,
    private _commonService: CommonService,
    private _widgetHelper: WidgethelperService
  ) { }

  chartOptions() {
    return {
      color: ['#3398DB'],
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        }
      },
      grid: {
        left: '4%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      xAxis: [
        {
          type: 'category',
          data: [],
          axisTick: {
            alignWithLabel: true
          },
          axisLabel: {
            interval: 0,
            length: "100%",
            color: "#fff",
            margin: 20,
            formatter: this._widgetHelper.NameWrapper
          },
          axisLine: {
            lineStyle: {
              color: '#fff'
            }
          }
        }
      ],
      yAxis: [
        {
          type: 'value',
          axisLabel: {
            interval: 0,
            length: "100%",
            //rotate: 30,
            color: "#fff"
          },
          axisLine: {
            lineStyle: {
              color: '#fff'
            }
          },
          splitLine: {
            show: false
          },
        }
      ],
      series: [
        {
          name: 'Total Open Order',
          type: 'bar',
          label: {
            normal: {
              show: true,
              position: 'top'
            }
          },
          barWidth: '30',
          data: []
        }
      ]
    };
  }

  init(widget: any) {
    console.log("Total Open Order");
    widget.dataLoaded = false;
    let currentDateTime = moment()
      .toDate()
      .getTime();
    widget.Title = "Total Open Order";
    widget.initcreationtime = currentDateTime;
    widget.widgetcreationtime = currentDateTime;
    if (!widget.hub) {
      widget.hub = this._dashboardService.startConnection();
    }

    widget.hub
      .start()
      .then(() => {
        console.log("Connection started!");
        widget.ConnectionId = widget.hub.id;
        let userPref: UserPreference = this._commonService.getUserPreference();
        widget.hub.listenFor("broadcastOpenOrder").subscribe(
          (result: any) => {
            console.log("broadcastOpenOrder", result);

            let resultwid;
            let resultcreationtime;
            let lastUpdatedTime;

            if (result && result.length > 0) {
              //console.log(result[0].IsNoDataFound);
              widget.IfNoDataFound = result[0].IsNoDataFound;
              resultwid = result[0].widgetid;
              resultcreationtime = result[0].widgetcreationtime;
              lastUpdatedTime = result[0].LastUpdateTime;
            }
            else {
              widget.errorMessage = errorMessages.noWidgetData;
            }

            if (resultwid == widget.widgetId && resultcreationtime == widget.widgetcreationtime) {
              widget.dataLoaded = false;
              widget.chartOptions = this.chartOptions();
              widget.errorMessage = null;
              let series = [];
              let xaxis = [];

              result.forEach(el => {
                series.push(el.OB_OPEN_ORDERS_COUNT);
                xaxis.push(el.MONTH_ABBR_NAME);
              });

              if (widget.IfNoDataFound) {
                widget.errorMessage = errorMessages.noWidgetData;
              }
              else {
                widget.errorMessage = null;
              }
              widget.chartOptions.series[0].data = series;
              widget.chartOptions.xAxis[0].data = xaxis;
            }
            widget.dataLoaded = true;
            this._commonService.lastUpdatedTime = lastUpdatedTime;
          },
          err => {
            console.log("listenFor broadcastOpenOrder error", err);
          }
        );

        let widgetData: any = {};
        widgetData = this._commonService.deepClone(widget.widgetsettings);
        widgetData.WidgetType = "TOTALOPENORDERS";
        widgetData.CreatedTime = widget.widgetcreationtime;
        widgetData.CustomerId = userPref.CustomerId;
        widgetData.Facility = userPref.FacilityId;
        widgetData.LastUpdate = "31-Jan-2017";
        widgetData.WidgetId = widget.widgetId;

        widgetData.ConnectionId = widget.hub.id;
        widget.hub
          .invoke("GetWidgetData", widgetData)
          .then(data => {
            console.log('GetWidgetData', data);
          })
          .catch(err => {
            console.log("Error GetWidgetData", err);
          });
      })
      .catch(err => {
        console.log("Error while establishing connection", err);
      });
  }
  remove(widget: any) {
    this._widgetHelper.remove(widget);
  }
  reload(widget: any) {
    this._widgetHelper.reload(widget);
  }


  tooltipWithPct(params): string {
    let tip: string = '';
    if (Array.isArray(params) && params.length > 0) {
      tip = params[0].axisValueLabel + '</br>'
      params.forEach(function (item) {
        tip = tip + '<span style="display:inline-block;margin-right:5px;'
          + 'border-radius:10px;width:9px;height:9px;background-color:'
          + item.color + ';"></span>' + item.seriesName + ' : ' + item.data.toFixed(2) + '%</br>';
        let val = parseFloat(item.data[1]);
      });
    }
    return tip;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/widgets/openorder.service.ts